import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Typography
} from '@material-ui/core'
import React, { useState } from 'react'

export function EditDetailsDialog(props: { apply: Function; visible: boolean; close: Function }) {
  const { apply, visible, close } = props
  const [title, setTitle] = useState('' as string)
  const [message, setMessage] = useState('' as string)

  function applyChanges() {
    apply(title, message)
  }

  return (
    <Dialog fullWidth={true} open={visible} aria-labelledby='alert-dialog-title'>
      <DialogTitle id='alert-dialog-title' className='highlight'>
        <Typography variant='body1'>
          <b>Edit Details</b>
        </Typography>
      </DialogTitle>
      <DialogContent>
        <Box>
          <TextField
            className='fill margin-bottom'
            label='PR Title'
            multiline
            rowsMax={4}
            value={title}
            onChange={(e: any) => {
              setTitle(e.target.value)
            }}
          />
        </Box>
        <Box>
          <TextField
            className='fill margin-bottom'
            label='Commit Message'
            multiline
            rowsMax={4}
            value={message}
            onChange={(e: any) => {
              setMessage(e.target.value)
            }}
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button
          color='secondary'
          onClick={() => {
            close()
          }}
        >
          Close
        </Button>
        <Button color='primary' autoFocus onClick={applyChanges}>
          Apply
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default EditDetailsDialog
